import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ProductService } from 'src/app/services/product.service';
import { environment } from 'src/environments/environment';
import { SimpleFieldConfig } from '../simple-field.interface';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnDestroy {

  sanitizedUrl: string = '';

  url = '';


  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  text: string;
  public serverPath = environment.commonImageApi + 'gallery/';
  value: any;
  constructor(
    private snackBar: MatSnackBar,
    private productService: ProductService, private router: Router) {
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  ngOnInit(): void {
    this.text = "Save"
    this.value= this.group.value[this.field.name];
  }
  imageVisible: boolean = true;
  imageDelete: boolean;
  imagesToRemoved: any = [];
 
  
  getResult(event) {
    this.imageVisible = true;

    this.group.value[this.field.name]=event.productEntityMediaGallery[0].fileName
    this.group.patchValue(this.group.value)
    this.value= this.group.value[this.field.name];
  }
  cancelUpload() {
    this.imageVisible = true;
  }

  logo() {
    this.imageVisible = false;
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
